export type CollectionTicketClaimRevokeStrategyDTO =
  (typeof CollectionTicketClaimRevokeStrategyDTO)[keyof typeof CollectionTicketClaimRevokeStrategyDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionTicketClaimRevokeStrategyDTO = {
  none: 'none',
  revoke: 'revoke',
} as const;
